var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"sub"},[_c('span',{staticClass:"tagline"},[_vm._v(_vm._s(_vm.tagline))]),_c('br'),_vm._l((_vm.contacts),function(contact,index){return _c('a',{key:index,staticClass:"icons",attrs:{"href":contact.link,"aria-label":contact.label}},[_c('fa-icon',{attrs:{"name":contact.icon}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }